import { applyDevLogin } from "./utils/devLogin";

// Imported first by index.tsx: the session must be in place before AuthProvider reads it, which
// happens as soon as its module loads.
applyDevLogin();
